import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    start_date: null,
    end_date: null,
    bankList: {
        offset: 0,
        limit: 10,
    },
    bankInactiveList: {
        offset: 0,
        limit: 10,
    },
}

const bankSlice = createSlice({
    name: 'bank',
    initialState,
    reducers: {
        setBankStartDate: (state, action) => {
            state.start_date = action.payload;
        },
        setBankEndDate: (state, action) => {
            state.end_date = action.payload;
        },
        setActiveOffset: (state, action) => {
            state.bankList.offset = action.payload;
        },
        setActiveLimit: (state, action) => {
            state.bankList.limit = action.payload;
        },
        setInactiveOffset: (state, action) => {
            state.bankInactiveList.offset = action.payload;
        },
        setInactiveLimit: (state, action) => {
            state.bankInactiveList.limit = action.payload;
        },
        reset: (state) => {
            return initialState;
        },

    },
});

export const {
    setBankStartDate,
    setBankEndDate,
    setActiveOffset,
    setActiveLimit,
    setInactiveOffset,
    setInactiveLimit,
    reset
} = bankSlice.actions;

export default bankSlice.reducer;